import { GameId } from '@bg-shared/enums/GameId';
import { Store } from '@betgames/bg-state-manager';
import { StoresEntity } from '@bg-shared/business/StoreFeature/StoresEntity';
import { ChipActionType } from '@bg-shared/business/CasinoBetting/enums';
import { IChipAction } from '../interfaces';

export const casinoBetActionsEntity = new StoresEntity(
    class CasinoBetActions extends Store<IChipAction[][]> {
        constructor(gameId: GameId) {
            super({
                key: `CasinoBetActions/${gameId}`,
                default: [],
            });
        }

        public add(data: IChipAction | IChipAction[]): void {
            this.update((draft) => {
                draft.push(Array.isArray(data) ? data : [data]);
            });
        }

        public undoOptimistic(): void {
            if (this.value[this.value.length - 1]?.[0].type === ChipActionType.SECTOR_CHOICE) {
                this.update(this.value.slice(0, -1));
                return;
            }

            this.update((draft) => {
                let indexToUpdate = draft.length - 1;

                while (indexToUpdate >= 0 && draft[indexToUpdate][0].pendingUndo) {
                    indexToUpdate--;
                }

                if (indexToUpdate >= 0) {
                    draft[indexToUpdate][0].pendingUndo = true;
                }
            });
        }

        public resolvePendingUndo(): void {
            this.update(this.value.filter((action) => !action[0].pendingUndo));
        }

        public removePendingUndoKey(): void {
            this.update((draft) => {
                draft.forEach((sequence) => {
                    sequence.forEach((action) => {
                        action.pendingUndo = null;
                    });
                });
            });
        }

        public markAsValidated(): void {
            this.update((draft) => {
                draft.forEach((sequence) => {
                    sequence.forEach((action) => {
                        if ('validated' in action) {
                            action.validated = true;
                        }
                    });
                });
            });
        }

        public filterOutInvalid(): void {
            this.update((draft) =>
                draft.filter((sequence) => {
                    if (!('validated' in sequence[0])) {
                        return sequence;
                    }

                    return sequence.every((action) => 'validated' in action && action.validated);
                }),
            );
        }
    },
);
